import { useNavigate } from 'react-router-dom';
import { Sprout } from 'lucide-react';
import { useI18n } from '../i18n';
import PlayBadge from './PlayBadge';

// Slim banner shown on public pages when the visitor is not logged in.
export default function GuestBanner() {
    const { t } = useI18n();
    const navigate = useNavigate();
    return (
        <div
            data-testid="guest-banner"
            className="sticky top-0 z-40 bg-brand-green text-white px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm shadow-sm"
        >
            <Sprout size={16} strokeWidth={2} className="shrink-0 hidden sm:block" />
            <span className="leading-snug">{t('guest.banner_text')}</span>
            <button
                data-testid="guest-banner-signup"
                onClick={() => navigate('/register')}
                className="shrink-0 bg-white text-brand-green hover:bg-brand-bg px-3.5 py-1.5 rounded-full font-medium text-xs transition-colors"
            >
                {t('guest.signup')}
            </button>
            <button
                data-testid="guest-banner-login"
                onClick={() => navigate('/login')}
                className="shrink-0 underline underline-offset-2 text-white/90 hover:text-white text-xs font-medium"
            >
                {t('guest.login')}
            </button>
            <PlayBadge variant="sm" />
        </div>
    );
}
